import { emitCustomEvent } from 'react-custom-events';

import axios from 'axios';

type HttpMethod = 'get' | 'post' | 'put' | 'patch' | 'delete';

type AxiosFnWithBody<T> = (url: string, data: unknown) => Promise<{ data: T }>;
type AxiosFnNoBody<T> = (url: string) => Promise<{ data: T }>;

function axiosCall<T>(method: HttpMethod) {
    return async (path: string, data: unknown = {}): Promise<T | undefined> => {
        try {
            const url = '/api/' + path;
            const needsBody = ['patch', 'put', 'post'].includes(method);
            let response: { data: T };
            if (needsBody) {
                response = await (axios[method] as AxiosFnWithBody<T>)(url, data);
            } else {
                response = await (axios[method] as AxiosFnNoBody<T>)(url);
            }
            if (response?.data) {
                return response.data;
            }
            throw new Error('no data');
        } catch (e) {
            const err = e as { request?: { status?: number } };
            const status = err?.request?.status;
            let error = 'Network error!';
            if (status !== undefined && status >= 500) {
                error = 'Server error!';
            }
            emitCustomEvent('lediumApiError', error);
        }
    };
}

const lediumApi = {
    get: <T>(path: string) => axiosCall<T>('get')(path),
    post: <T>(path: string, data: unknown) => axiosCall<T>('post')(path, data),
    delete: <T>(path: string) => axiosCall<T>('delete')(path),
    put: <T>(path: string, data: unknown) => axiosCall<T>('put')(path, data),
    patch: <T>(path: string, data: unknown) => axiosCall<T>('patch')(path, data)
};

export default lediumApi;
